<nb-card>
  <nb-card-header>
    <div class="row no-margin middle-xs">
      <div class="col-xs-10 no-margin no-padding">
        <strong>{{ record?.name }}</strong>
      </div>
      <div class="col-xs-2 no-margin no-padding">
        <button class="margin float-end" nbButton shape="round" (click)="ref.close()">
          <nb-icon icon="close"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <app-gallery-record-detail [record]="record"></app-gallery-record-detail>
    <br />
    <button class="margin" nbButton shape="round" status="info" (click)="viewImages()">
      View Photos
      <nb-icon icon="image-outline"></nb-icon>
    </button>
  </nb-card-body>
  <nb-card-footer>
    <app-add-to-cart
      *ngIf="record.activeLineItems && record.activeLineItems.length === 1"
      [lineItem]="record.activeLineItems[0]"
      [galleryRecord]="record"
      (added)="ref.close()"
    ></app-add-to-cart>
    <small>{{ record?.id }}</small>
  </nb-card-footer>
</nb-card>
